import { TableSkeleton } from '@/components/common/DataTable';
import { Skeleton } from '@/components/ui/skeleton';

interface DetailLinesSkeletonProps {
  columnCount: number;
}

export function DetailLinesSkeleton({ columnCount }: DetailLinesSkeletonProps) {
  return (
    <div className="flex flex-col gap-2" aria-busy="true">
      <Skeleton className="h-4 w-36" />
      <TableSkeleton columnCount={columnCount} className="rounded-xl" />
    </div>
  );
}
